import classNames from 'classnames';
import React from 'react';

type FieldProps = {
  label: string | JSX.Element;
  /** @debt: Should drop 'string'. Plain text should at least be wrapped in a typography component. */
  children: string | JSX.Element;
  description?: string | JSX.Element;
  trailingDescription?: string | JSX.Element;
  /** Tighter vertical spacing (`vertical-gap-4`). Default matches DefaultFormItem (`vertical-gap-8`). */
  compact?: boolean;
  disabled?: boolean;
};

/** @see https://www.figma.com/design/Vvl7WmeGXXmS948pRsQNKE/Farmbot-Outback-Design-System?node-id=415-881&t=YD45czseiNX3OxTA-4 */
function Field({
  children,
  compact = false,
  disabled = false,
  description,
  label,
  trailingDescription
}: FieldProps) {
  const withDisabled = (baseClass: string) => classNames(baseClass, { 'text-disabled': disabled });
  return (
    <div className={classNames('w-full', compact ? 'vertical-gap-4' : 'vertical-gap-8')}>
      <div className={withDisabled('body-emphasis-copy')}>{label}</div>
      {description && <div className={withDisabled('body-muted-copy')}>{description}</div>}
      {children}
      {trailingDescription && <div className={withDisabled('body-muted-copy')}>{trailingDescription}</div>}
    </div>
  );
}

export default Field;
export type { FieldProps };